import { render, staticRenderFns } from "./v-sign.vue?vue&type=template&id=c9c3d87c&scoped=true&"
import script from "./v-sign.vue?vue&type=script&lang=js&"
export * from "./v-sign.vue?vue&type=script&lang=js&"
import style0 from "./v-sign.vue?vue&type=style&index=0&id=c9c3d87c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c3d87c",
  null
  
)

export default component.exports